import { Button } from '~/components/elements/Button'

type Props = React.ComponentProps<typeof Button> & {
  href: string
}
export const BuyButton: React.FC<Props> = ({ children, ...props }) => {
  return (
    <div className="w-[88px] font-bold xl:w-[180px]">
      <Button {...props}>
        <div className="py-[9px]">{children}</div>
      </Button>
    </div>
  )
}
